import { CommonModule } from '@angular/common';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { SharedEnvModule } from '@libraries/shared-env';
import { FeaturesService } from './features.service';
import { LaunchDarklyService } from './launch-darkly.service';

export function LAUNCH_DARKLY_APP_INITIALIZER(
  featuresService: FeaturesService,
  launchDarklyService: LaunchDarklyService
) {
  if (launchDarklyService.hasClientId()) {
    return () => launchDarklyService.getFlags().toPromise();
  } else {
    return () =>
      new Promise<void>((resolve) => {
        resolve();
      });
  }
}

@NgModule({
  //TODO: do we need this SharedEnv? Refactor this and get rid of this module in future.
  imports: [CommonModule, SharedEnvModule],
  providers: [
    FeaturesService,
    LaunchDarklyService,
    provideAppInitializer(() => {
        const initializerFn = (LAUNCH_DARKLY_APP_INITIALIZER)(inject(FeaturesService), inject(LaunchDarklyService));
        return initializerFn();
      }),
  ],
})
export class FeatureFlagsModule {}
